<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <provider-editor
        v-model="form"
        :logo-url="logoUrl"
        :is-disable="isDisable"
        class="editor"
      ></provider-editor>
      <div class="text-end">
        <sc-button :disabled="isSaving" variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import { uploadPublicImage } from "@/god";
import { isValidPhone } from "@/lib/util";
import ProviderEditor from "../components/ProviderEditor";

export default {
  components: {
    PageWrapper,
    ScButton,
    ProviderEditor
  },
  data() {
    const title = "เพิ่มผู้ให้บริการ​";
    const addressForm = {
      province: null,
      zipCode: null,
      amphurName: null,
      tumbonName: null,
    }

    const form = {
      name: null,
      remark: null,
      logoFile: null,
      providerType: "INDIVIDUAL",
      nameOnSap: null,
      taxId: null,
      houseNo: null,
      streetAddress: null,
      addressForm,
      mobileNumber: null,
      isVatRegistered: null
    };

    const logoUrl = null;

    return {
      title,
      form,
      logoUrl,
      isDisable: false,
      isSaving: false
    };
  },
  watch: {
    form(form, oldForm) {
      if (this.form.logoFile === oldForm.logoFile) {
        return;
      }

      this.logoUrl = URL.createObjectURL(this.form.logoFile);
    }
  },
  methods: {
    async handleClickSave() {
      if (this.isSaving) return;
      this.isSaving = true;
      try {
        await this.createProvider();
        this.$router.push({ name: "ProviderListPage" });
      } catch (err) {
        if (err !== 200) {
          this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        }
      } finally {
        this.isSaving = false;
      }
    },
    async createProvider() {
      const {
        name,
        remark,
        logoFile,
        nameOnSap,
        taxId,
        providerType,
        addressForm,
        streetAddress,
        mobileNumber,
        houseNo,
        isVatRegistered
      } = this.form;

      const isVatRegisteredTypeBoolean = typeof isVatRegistered === "boolean"

      this.checkValueToShowAlertMessage(!logoFile, 'กรุณาใส่โลโก้')
      this.checkValueToShowAlertMessage(!name || !nameOnSap, 'กรุณากรอกชื่อบน app / บน sap')
      this.checkValueToShowAlertMessage(!taxId, 'กรุณากรอก TaxID')
      this.checkValueToShowAlertMessage(
        taxId && taxId.length < 10,
        'สามารถใส่ TaxID ระหว่าง 10-13 ตัวอักษร'
      )
      this.checkValueToShowAlertMessage(!houseNo, 'กรุณากรอก บ้านเลขที่')
      this.checkValueToShowAlertMessage(!addressForm.zipCode, 'กรุณาเลือก รหัสไปรษณีย์')
      this.checkValueToShowAlertMessage(!addressForm.province, 'กรุณาเลือก จังหวัด')
      this.checkValueToShowAlertMessage(!addressForm.amphurName, 'กรุณาเลือก อำเภอ / เขต')
      this.checkValueToShowAlertMessage(!addressForm.tumbonName, 'กรุณาเลือก ตำบล / แขวง')
      this.checkValueToShowAlertMessage(!streetAddress, 'กรุณากรอก ที่อยู่ (หมู่บ้าน , ซอย , ถนน)')
      this.checkValueToShowAlertMessage(!isVatRegisteredTypeBoolean, 'กรุณาเลือก จดVat')
      this.checkValueToShowAlertMessage(!mobileNumber, 'กรุณากรอกเบอร์โทรศัพท์')
      this.checkValueToShowAlertMessage(mobileNumber && !isValidPhone(mobileNumber), 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง')

      const icon = await uploadPublicImage(logoFile, name, "article");

      const params = {
        name,
        remark,
        icon,
        name_on_sap: nameOnSap,
        tax_id: taxId,
        provider_type: providerType,
        house_no: houseNo,
        province: addressForm.province,
        zip_code: addressForm.zipCode,
        amphur_name: addressForm.amphurName,
        tumbon_name: addressForm.tumbonName,
        street_address: streetAddress,
        mobile_number: mobileNumber,
        is_vat_registered: isVatRegistered
      };

      const response = await baanRueJaiClient.admin.subscriptions.providers.post(
        params
      );

      return response.data.result;
    },
    checkValueToShowAlertMessage(isAlert, message) {
      if (isAlert) {
        this.$message.error(message);
        throw new Error(message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
